<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <!-- ================= ตัวกรอง ================= -->
    <div class="card">
      <div class="card-body">
        <h2 class="text-dark font-medium-3 mb-1">
          <i class="fa fa-search" /> ดูภาพรวมของระบบตามวัน เวลา
        </h2>
        <div class="row align-items-end">
          <div class="col-6 col-md-2">
            <div class="form-group">
              <label>สกุลเงิน</label>
              <b-form-select
                v-model="currency"
                :options="currencyOPs"
              />
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <label>วันที่เริ่มต้น</label>
              <flat-pickr
                v-model="dateStart"
                class="form-control"
                placeholder="เลือกเวลาเริ่มต้น"
              />
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <label>วันที่สิ้นสุด</label>
              <flat-pickr
                v-model="dateEnd"
                class="form-control"
                placeholder="เลือกเวลาสิ้นสุด"
              />
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <button
                class="btn btn-gradient-dark btn-block"
                @click="getData()"
              >
                <feather-icon icon="SearchIcon" />
                ค้นหา
              </button>
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <button
                class="btn btn-gradient-success btn-block"
                @click="ExportDep()"
              >
                <i class="fal fa-file-excel" /> Export ฝาก
              </button>
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="form-group">
              <button
                class="btn btn-gradient-danger btn-block"
                @click="ExportWith()"
              >
                <i class="fal fa-file-excel" /> Export ถอน
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= สมาชิก / โบนัส ================= -->
    <div class="kpi-grid mb-2">
      <div
        v-for="kpi in kpis"
        :key="kpi.label"
        :class="kpi.cls"
        class="kpi-card white"
      >
        <div class="p-1">
          <span><i :class="kpi.icon" /> {{ kpi.label }}</span>
          <h4 class="text-white mb-0 mt-50">
            {{ kpi.value }}
          </h4>
        </div>
        <div class="card-b">
          <small>ข้อมูลตามช่วงเวลา</small>
        </div>
      </div>
    </div>

    <!-- ================= สรุปยอดเงิน ================= -->
    <div class="row match-height">
      <div class="col-12 col-md-4 mb-1">
        <div class="card-cradit-total white summary-card">
          <div class="p-1">
            <span><i class="far fa-money-check-edit-alt" /> ยอดฝากรวม</span>
            <h3 class="text-white my-50">
              {{ Commas(depositTotal) }} {{ unit }}
            </h3>
            <div class="d-flex justify-content-between">
              <small>Auto / Slip : {{ Commas(depositAuto) }}</small>
              <small>Manual : {{ Commas(depositManual) }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-1">
        <div class="card-cradit-3 white summary-card">
          <div class="p-1">
            <span><i class="fal fa-hand-holding-usd" /> ยอดถอนรวม</span>
            <h3 class="text-white my-50">
              {{ Commas(withdrawTotal) }} {{ unit }}
            </h3>
            <div class="d-flex justify-content-between">
              <small>Auto : {{ Commas(withdrawAuto) }}</small>
              <small>Manual : {{ Commas(withdrawManual) }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 mb-1">
        <div
          :class="netTotal >= 0 ? 'card-cradit-1' : 'card-cradit-pink'"
          class="white summary-card"
        >
          <div class="p-1">
            <span><i class="fal fa-balance-scale" /> ส่วนต่างฝาก-ถอนเครดิต</span>
            <h3 class="text-white my-50">
              {{ Commas(netTotal) }} {{ unit }}
            </h3>
            <div class="d-flex justify-content-between">
              <small>ฝากรวม - ถอนรวม</small>
              <small>{{ netTotal >= 0 ? 'กำไร' : 'ขาดทุน' }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= ยอดฝากแยกตามช่องทาง ================= -->
    <div class="card">
      <div class="card-body">
        <h4 class="mb-1">
          <i class="far fa-envelope-open-dollar" /> ยอดฝากแยกตามช่องทาง
        </h4>

        <div class="table-responsive">
          <table class="table table-hover channel-table mb-0">
            <thead>
              <tr>
                <th>ช่องทาง</th>
                <th class="text-right">
                  Auto / Slip
                </th>
                <th class="text-right">
                  Manual
                </th>
                <th class="text-right">
                  รวม
                </th>
                <th class="share-col">
                  สัดส่วน
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="ch in channels"
                :key="ch.key"
                :class="{ 'channel-highlight': ch.highlight }"
              >
                <td>
                  <div class="d-flex align-items-center">
                    <span
                      class="channel-dot"
                      :style="{ background: ch.color }"
                    />
                    <img
                      :src="ch.icon"
                      :alt="ch.name"
                      class="bank-icon"
                    >
                    <div>
                      <div class="font-weight-bold">
                        {{ ch.name }}
                      </div>
                      <small
                        v-if="ch.note"
                        class="text-muted"
                      >{{ ch.note }}</small>
                      <small
                        v-if="ch.error"
                        class="text-warning d-block"
                      >{{ ch.error }}</small>
                      <router-link
                        v-else-if="ch.link"
                        :to="ch.link"
                        class="d-block small"
                      >
                        ดูรายละเอียด
                      </router-link>
                    </div>
                  </div>
                </td>
                <td class="text-right">
                  {{ Commas(ch.auto) }}
                </td>
                <td class="text-right">
                  {{ Commas(ch.manual) }}
                </td>
                <td class="text-right font-weight-bold">
                  {{ Commas(ch.auto + ch.manual) }}
                </td>
                <td class="share-col">
                  <div class="d-flex align-items-center">
                    <div class="share-bar flex-grow-1 mr-50">
                      <div
                        class="share-bar-fill"
                        :style="{ width: share(ch) + '%', background: ch.color }"
                      />
                    </div>
                    <small class="share-text">{{ share(ch).toFixed(1) }}%</small>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>ยอดรวม</th>
                <th class="text-right">
                  {{ Commas(depositAuto) }}
                </th>
                <th class="text-right">
                  {{ Commas(depositManual) }}
                </th>
                <th class="text-right">
                  {{ Commas(depositTotal) }} {{ unit }}
                </th>
                <th class="share-col" />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import moment from 'moment-timezone'
import {
  BFormSelect,
  BOverlay,
  BIconController,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

const emptyData = () => ({
  usernewdays: 0,
  bonus: [],
  withdraws: [],
  withdraws_manual: [],
  scb: { auto_scb: [], manual_scb: [] },
  gsb: { auto_gsb: [], manual_gsb: [] },
  ktb: { auto_ktb: [], manual_ktb: [] },
  bay: { auto_bay: [], manual_bay: [] },
  bbl: { auto_bbl: [], manual_bbl: [] },
  ttb: { auto_ttb: [], manual_ttb: [] },
  kkp: { auto_kkp: [], manual_kkp: [] },
  kbank: { auto_kbank: [], manual_kbank: [] },
  truewallet: { auto_true: [], manual_true: [] },
  payment: { auto_payment: [], manual_payment: [] },
  autopeer: {},
  autopeerDirect: {
    auto: 0, auto_count: 0, manual: 0, manual_count: 0,
  },
  krbank: {
    dep_kr: [],
    depkr_manual: [],
    withdraws_kr: [],
    withdraws_manual_kr: [],
    bonus_kr: [],
    regisanddep_kr: 0,
    depfirst_kr: 0,
  },
  regisanddep: 0,
  depfirst: 0,
  active: 0,
})

// รวมยอดจาก array ของรายการ (field = amount/bonus) หรือคืนค่าตัวเลขตรงๆ
const sum = (list, field = 'amount') => {
  if (Array.isArray(list)) return list.reduce((prev, curr) => prev + Number(curr[field] || 0), 0)
  return Number(list || 0)
}

export default {
  components: {
    flatPickr,
    BFormSelect,
    BOverlay,
    BIconController,
  },
  data() {
    return {
      currency: 'THB',
      currencyOPs: ['THB', 'KRW'],
      show: false,
      dateStart: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
      dateEnd: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
      DataShow: emptyData(),
      // แหล่งข้อมูล AutoPeer: 'direct' = AutoPeer Direct (autopeerDirect), 'mbet' = AutoPeer Mbet (autopeer)
      autopeerMode: 'mbet',
    }
  },
  computed: {
    isTHB() {
      return this.currency === 'THB'
    },
    unit() {
      return this.isTHB ? 'บาท' : 'KRW'
    },
    kpis() {
      const d = this.DataShow
      const kr = d.krbank || {}
      return [
        {
          label: 'เปิดยูส', icon: 'fal fa-users', cls: 'card-cradit-1', value: `${this.Commas(d.usernewdays)} คน`,
        },
        {
          label: 'สมัครและเติม', icon: 'fal fa-user-plus', cls: 'card-cradit-blue', value: `${this.Commas(this.isTHB ? d.regisanddep : kr.regisanddep_kr)} คน`,
        },
        {
          label: 'เติมเงินครั้งแรก', icon: 'fal fa-hand-holding-usd', cls: 'card-cradit-yellow', value: `${this.Commas(this.isTHB ? d.depfirst : kr.depfirst_kr)} คน`,
        },
        {
          label: 'Active', icon: 'fal fa-signal', cls: 'card-cradit-pink', value: `${this.Commas(d.active)} คน`,
        },
        {
          label: 'จ่ายโบนัส', icon: 'fal fa-donate', cls: 'card-cradit-2', value: `${this.Commas(sum(this.isTHB ? d.bonus : kr.bonus_kr, 'bonus'))} ${this.unit}`,
        },
      ]
    },
    channels() {
      const d = this.DataShow
      if (!this.isTHB) {
        const kr = d.krbank || {}
        return [
          {
            key: 'kr', name: 'ธนาคารเกาหลี', icon: '/bankIcon/hana.webp', color: '#009692', auto: sum(kr.dep_kr), manual: sum(kr.depkr_manual),
          },
        ]
      }
      const bank = (key, name, icon, color, group) => ({
        key,
        name,
        icon,
        color,
        auto: sum((d[group] || {})[`auto_${key}`]),
        manual: sum((d[group] || {})[`manual_${key}`]),
      })
      return [
        {
          key: 'autopeer',
          name: this.isMbet ? 'AutoPeer Mbet' : 'AutoPeer',
          icon: '/bankIcon/autopeer.png',
          color: '#0ea5e9',
          auto: this.apDeposit.auto,
          manual: this.apDeposit.manual,
          note: this.apDeposit.note,
          error: this.apDeposit.error,
          link: this.isMbet ? { name: 'autopeer-mbet-credit' } : null,
          highlight: true,
        },
        bank('scb', 'ธนาคารไทยพาณิชย์', '/bankIcon/scb.png', '#4a367f', 'scb'),
        bank('kbank', 'ธนาคารกสิกรไทย', '/bankIcons/kbank.svg', '#138f2d', 'kbank'),
        bank('bay', 'ธนาคารกรุงศรีฯ', '/bankIcon/BAY.png', '#d9a400', 'bay'),
        bank('ktb', 'ธนาคารกรุงไทย', '/bankIcon/KTB.png', '#1ba5e1', 'ktb'),
        bank('bbl', 'ธนาคารกรุงเทพ', '/bankIcon/BBL.png', '#1e3a8a', 'bbl'),
        bank('gsb', 'ธนาคารออมสิน', '/bankIcon/GSB.png', '#e8248d', 'gsb'),
        bank('ttb', 'ธนาคารทหารไทยธนชาต', '/bankIcon/ttb.png', '#0050f0', 'ttb'),
        bank('kkp', 'ธนาคารเกียรตินาคิน', '/bankIcon/kkp.png', '#5b4a99', 'kkp'),
        {
          key: 'true', name: 'ทรูมันนี่ วอลเล็ท', icon: '/bankIcon/true.svg', color: '#ff6b00', auto: sum(d.truewallet?.auto_true), manual: sum(d.truewallet?.manual_true),
        },
        {
          key: 'payment', name: 'Payment Gateway', icon: '/bankIcon/payment.png', color: '#ff39c9', auto: sum(d.payment?.auto_payment), manual: sum(d.payment?.manual_payment),
        },
      ]
    },
    isMbet() {
      return this.autopeerMode === 'mbet'
    },
    apDeposit() {
      if (this.isMbet) {
        // AutoPeer Mbet: ยอดจาก AutoPeer service (autopeer) — ชดเชย timeout รวมอยู่ใน manual แล้ว
        const ap = this.DataShow.autopeer || {}
        const auto = Number(ap.totalAutoDeposit || 0)
        const manual = Number(ap.totalManualDeposit || 0)
        const notes = [`${this.Commas((ap.deposits || []).length)} รายการ`]
        if (Number(ap.timeoutCompensationCount || 0) > 0) {
          notes.push(`ชดเชย ${this.Commas(ap.timeoutCompensationDeposit)} บาท (${this.Commas(ap.timeoutCompensationCount)} รายการ)`)
        }
        return {
          auto, manual, total: auto + manual, note: notes.join(' · '), error: ap.error || null,
        }
      }
      const ap = this.DataShow.autopeerDirect || {}
      const auto = Number(ap.auto || 0)
      const manual = Number(ap.manual || 0)
      const count = Number(ap.auto_count || 0) + Number(ap.manual_count || 0)
      return {
        auto, manual, total: auto + manual, note: `${this.Commas(count)} รายการ`, error: null,
      }
    },
    depositAuto() {
      return this.channels.reduce((prev, ch) => prev + ch.auto, 0)
    },
    depositManual() {
      return this.channels.reduce((prev, ch) => prev + ch.manual, 0)
    },
    depositTotal() {
      return this.depositAuto + this.depositManual
    },
    withdrawAuto() {
      return this.isTHB ? sum(this.DataShow.withdraws) : sum(this.DataShow.krbank?.withdraws_kr)
    },
    withdrawManual() {
      return this.isTHB ? sum(this.DataShow.withdraws_manual) : sum(this.DataShow.krbank?.withdraws_manual_kr)
    },
    withdrawTotal() {
      return this.withdrawAuto + this.withdrawManual
    },
    netTotal() {
      return this.depositTotal - this.withdrawTotal
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    share(ch) {
      if (!this.depositTotal) return 0
      return ((ch.auto + ch.manual) / this.depositTotal) * 100
    },
    ExportDep() {
      this.exportFile('ExportDep', 'Report Depsit.xlsx')
    },
    ExportWith() {
      this.exportFile('ExportWith', 'Report Withdraw.xlsx')
    },
    exportFile(path, filename) {
      const Time = moment().tz('Asia/Bangkok').format('HH')
      if (Time !== '23' && Time !== '00' && Time !== '01') {
        this.SwalError('สามารถ Export ได้ในช่วงเวลา 23.00 - 01.00')
        return
      }
      this.show = true
      this.$http
        .get(`/export/${path}/${this.dateStart}/${this.dateEnd}`, {
          responseType: 'blob',
        })
        .then(response => {
          this.show = false
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          this.show = false
          console.log(error)
        })
    },
    getData() {
      this.show = true
      const params = {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
      }
      this.$http
        .post('/dashboard/GetDepAndWithNewDashboard', params)
        .then(response => {
          this.show = false
          this.DataShow = { ...emptyData(), ...response.data }
        })
        .catch(error => {
          this.show = false
          console.log(error)
        })
    },
    Commas(x) {
      if (!x) {
        return 0
      }
      if (x % 1 !== 0) {
        return Number(x)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style scoped>
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
}
.kpi-card,
.summary-card {
  border-radius: 0.428rem;
  overflow: hidden;
  height: 100%;
}
.bank-icon {
  width: 35px;
  height: 35px;
  padding: 3px;
  margin-right: 0.6rem;
  border-radius: 50%;
  object-fit: contain;
}
.channel-table td,
.channel-table th {
  vertical-align: middle;
  white-space: nowrap;
}
.channel-dot {
  width: 4px;
  height: 32px;
  border-radius: 2px;
  margin-right: 0.6rem;
  flex-shrink: 0;
}
.channel-highlight {
  background: rgba(14, 165, 233, 0.08);
}
.share-col {
  width: 200px;
  min-width: 160px;
}
.share-bar {
  height: 8px;
  border-radius: 4px;
  background: rgba(130, 134, 139, 0.2);
  overflow: hidden;
}
.share-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease;
}
.share-text {
  width: 44px;
  text-align: right;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
